Auth = require 'app/scripts/db/auth'
$ = require 'jquery'
log = require 'app/scripts/debug/log'
_ = require 'underscore'
f = require 'effing'
Promise = require 'bluebird'
ninvoke = require 'app/scripts/lib/util/ninvoke'
ApiError = require 'app/scripts/network/api-error'
xtend = require 'xtend'
getQueryParamByKey = require 'app/scripts/lib/util/url/get-query-param-by-key'
{ featureFlagClient } = require '@trello/feature-flag-client'
{ ErrorViews } = require 'app/common/data/error-views'
{ organizationRoutesViewLoaders } = require './organization-routes-view-loaders'

module.exports =
  routes: [
    ['org/:id', 'organizationById']
    [':name/members/guests', 'organizationGuestsView']
    [':name/members', 'organizationMembersView']
    [':name/:username/cards', 'organizationMemberCardsView']
    [':name/export', 'organizationExportView']
    [':name/power-ups', 'organizationPowerUpsView']
  ]

  organizationBoardsView: (orgname, viewOptions) ->
    organizationRoutesViewLoaders.loadOrganizationBoardsView()
    .then (OrganizationBoardsView) =>
      @displayOrganizationPage
        orgname: orgname
        loadFn: 'loadOrganizationBoardsData'
        additionalFns:
          members: 'loadOrganizationMemberGhost'
        viewClass: OrganizationBoardsView
        getLocation: @getOrganizationUrl
        viewOptions: viewOptions
      .done()

  organizationMembersView: (orgname) ->
    organizationRoutesViewLoaders.loadOrganizationMembersView()
    .then (OrganizationMembersView) =>
      @displayOrganizationPage
        orgname: orgname
        loadFn: 'loadOrganizationMembersData'
        viewClass: OrganizationMembersView
        getLocation: @getOrganizationMembersUrl
        viewOptions: @getMemberPageViewOptions(orgname, 'team-member')
        redirectAfterOrgLoad: @redirectToOrgBoardsAfterInviteSignup.bind(@)
      .done()

  # After signing up from a team invite email, users will be redirected to
  # /:orgname/members. Unconfirmed users have permission to view this page.
  # However, we would prefer for users to see /:orgname/home after signup, which
  # can only be seen by confirmed users that have automatically joined the team.
  # If the user is confirmed and a member of the team, redirect them again to
  # /:orgname/home
  redirectToOrgBoardsAfterInviteSignup: (organization) ->
    if !getQueryParamByKey('completedInviteSignup')?
      return { redirected: false }

    if !Auth.me()?.get('confirmed') || !organization.isMember(Auth.me())
      # Remove the ?completedInviteSignup query param, but otherwise do nothing
      @navigate(location.href, { trigger: false, replace: false })
      @navigate(@getOrganizationMembersUrl(organization.get('name')), { trigger: false, replace: false })
      return { redirected: false }

    @navigate(@getMemberOrgUrl(organization.get('name'), true, false), { trigger: true, replace: true })
    return { redirected: true }

  organizationGuestsView: (orgname) ->
    organizationRoutesViewLoaders.loadOrganizationMembersView()
    .then (OrganizationMembersView) =>
      @displayOrganizationPage
        orgname: orgname
        loadFn: 'loadOrganizationMembersData'
        viewClass: OrganizationMembersView
        getLocation: @getOrganizationGuestUrl
        viewOptions: @getMemberPageViewOptions(orgname, 'guest')
      .done()

  getMemberPageViewOptions: (orgname, memberFilterType) ->
    initialMemberTypeFilter: memberFilterType,
    routeToMemberType:
      (memberType) =>
        if memberType == 'team-member'
          @navigate(@getOrganizationMembersUrl(orgname), { trigger: false })
        else if memberType == 'guest'
          @navigate(@getOrganizationGuestUrl(orgname), { trigger: false })

  organizationMemberCardsView: (orgname, username) ->
    # This now lives on the member cards page
    @navigate(@getOrganizationMemberCardsUrl(orgname, username), { trigger: true })

  organizationAccountView: (orgname) ->
    organizationRoutesViewLoaders.loadOrganizationAccountView()
    .then (OrganizationAccountView) =>
      @displayOrganizationPage
        orgname: orgname
        loadFn: 'loadOrganizationData'
        viewClass: OrganizationAccountView
        getLocation: @getOrganizationAccountUrl
        membersOnly: true
      .done()

  organizationExportView: (orgname) ->
    organizationRoutesViewLoaders.loadOrganizationExportView()
    .then (OrganizationExportView) =>
      @displayOrganizationPage
        orgname: orgname
        loadFn: 'loadOrganizationExportData'
        viewClass: OrganizationExportView
        getLocation: @getOrganizationExportUrl
        adminOnly: true
        isPremium: true
      .done()

  organizationBillingView: (orgname, options = {}) ->
    featureFlagClient.ready().then =>
      slackPromoFlag = featureFlagClient.get('btg.slack-codes', false)
      hasPromoCode = slackPromoFlag && (new URLSearchParams(window.location.search)).get('promocode')?
      loader = if featureFlagClient.get('fv.billing-v2', false) && !hasPromoCode then 'loadOrganizationBillingView' else 'loadOrganizationBillingViewLegacy'
      organizationRoutesViewLoaders[loader]()
        .then (OrganizationBillingView) =>
          @displayOrganizationPage
            orgname: orgname
            loadFn: 'loadOrganizationData'
            viewClass: OrganizationBillingView
            getLocation: @getOrganizationBillingUrl
            urlOptions: { returnUrl: options.returnUrl }
          .done()

  organizationPowerUpsView: (orgname) ->
    organizationRoutesViewLoaders.loadOrganizationPowerUpsView()
    .then (OrganizationPowerUpsView) =>
      @displayOrganizationPage
        orgname: orgname
        loadFn: 'loadOrganizationBoardsData'
        viewClass: OrganizationPowerUpsView
        getLocation: @getOrganizationPowerUpsUrl
        adminOnly: true
        allowEnterpriseAdmin: true
        isPremium: true
      .done()

  headerOptsForOrg: (organization) ->
    if organization?.get('idEnterprise')? && organization?.getEnterprise()?
      enterprise = organization.getEnterprise()
      {
        headerBrandingColor: enterprise.get('prefs')?.brandingColor
        headerBrandingLogo: enterprise.getHeaderLogo()
        headerBrandingName: enterprise.get('displayName')
      }
    else
      {}

  displayOrganizationPage: (settings) ->
    # Dependency required at call site to avoid import cycles, do not lift to top of module
    Member = require 'app/scripts/models/member'
    # Dependency required at call site to avoid import cycles, do not lift to top of module
    ModelCache = require 'app/scripts/db/model-cache'
    # Dependency required at call site to avoid import cycles, do not lift to top of module
    ModelLoader = require 'app/scripts/db/model-loader'

    { orgname, username, product, urlOptions, viewOptions, redirectAfterOrgLoad } = settings

    log('controller', ['organization'])

    Promise.using @getSpinner(), =>
      ModelLoader.release 'top-level'
      ModelLoader.for 'top-level', settings.loadFn, orgname
      .tap (org) ->
        Promise.all _.values(settings.additionalFns ? {}).map (methodName) ->
          ModelLoader[methodName] org.id, username
      .then (organization) =>
        member = ModelCache.findOne(Member, 'username', username)

        if !(settings.allowEnterpriseAdmin && Auth.me().isEnterpriseAdminOf(id: organization.get('idEnterprise')))
          if (!organization.owned() && settings.adminOnly) ||
              (!organization.isMember(Auth.me()) && settings.membersOnly) ||
              (settings.isPremium && !organization.isPremium())
            @organizationBoardsView(orgname)
            return organization

        if redirectAfterOrgLoad?
          { redirected } = redirectAfterOrgLoad(organization)
          if redirected
            return

        @clearPreviousView()

        @setViewType(organization)

        options = _.extend({ urlOptions }, viewOptions)

        if member
          options.member = member

        if product?
          options.product = product

        options.modelCache = @getCurrentModelCache()

        organizationView = @topLevelView(settings.viewClass, organization, options)

        @showHeader(@headerOptsForOrg(organization))

        $('#trello-root').addClass('body-tabbed-page')
        $('#content')
          .empty()
          .append('<div class="js-boards-page-banners"></div><div class="js-boards-page"></div>')
          .append(organizationView.render().el)
        @focusContent()

        title = "#{organization.get('displayName')} (#{organization.get('name')})"

        loc = settings.getLocation.apply @, if member
          [organization.get('name'), member.get('username'), urlOptions]
        else if product
          [organization.get('name'), product, urlOptions]
        else
          [organization.get('name'), urlOptions]

        @setLocation
          title: title,
          location: loc

        return organization
      .catch ApiError.Unconfirmed, =>
        ninvoke ModelCache, 'waitFor', 'Member', Auth.myId()
        .then =>
          @displayErrorPage _.extend
            errorType: ErrorViews.UNCONFIRMED_ORG_NOT_FOUND
          , Auth.me().toJSON()
      .catch ApiError, =>
        @displayErrorPage()
